import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import ExitToApp from "@material-ui/icons/ExitToApp";
import ClearIcon from "@material-ui/icons/Clear";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { STTypography, STFab } from "./styles";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  onSubmit: () => Promise<void>;
}

@observer
export default class PersonLogout extends React.Component<IProps> {
  @observable logoutOpened: boolean = false;

  handleLogout = async () => {
    await this.props.onSubmit();
    this.logoutOpened = false;
  };

  handleOpenLogout = () => {
    this.logoutOpened = true;
  };

  handleCloseLogout = () => {
    this.logoutOpened = false;
  };
  render() {
    return (
      <React.Fragment>
        <RoundButton
            icon={<ExitToApp/>}
            tooltipTitle={Values.getLocalizationValue("logout")}
            onClick={() => this.handleOpenLogout()}
        />
        
        <SimpleModal
          width={200}
          isOpened={this.logoutOpened}
          onClose={this.handleCloseLogout}
        >
          <Grid
            container
            direction="column"
            justify="space-between"
            alignItems="center"
          >
            <STTypography>
              {Values.getLocalizationValue("areYouSureLogout")}
            </STTypography>
            <Grid container justify="center" wrap="nowrap">
              <STButtonMargin
                onClick={this.handleLogout}
                variant="contained"
                color="primary"
              >
                <ExitToApp />
              </STButtonMargin>
              <STButtonMargin
                onClick={this.handleCloseLogout}
                variant="contained"
              >
                <ClearIcon />
              </STButtonMargin>
            </Grid>
          </Grid>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
